// AUTO-GENERATED by scripts/generate-sitemap.mjs — do not edit.
// Small pre-computed brand index so /cameras can render a crawlable catalog
// index without importing src/data/cameras.ts into its client chunk.
export interface BrandIndexEntry { slug: string; name: string; cameraCount: number }
export interface OrphanCamera { slug: string; manufacturer: string; model: string }

/** Manufacturers with their own /brand/<slug> hub page. */
export const BRAND_INDEX: BrandIndexEntry[] = [
  {
    "slug": "hikvision",
    "name": "Hikvision",
    "cameraCount": 5886
  },
  {
    "slug": "dahua",
    "name": "Dahua",
    "cameraCount": 2341
  },
  {
    "slug": "uniview",
    "name": "Uniview",
    "cameraCount": 883
  },
  {
    "slug": "axis",
    "name": "Axis",
    "cameraCount": 844
  },
  {
    "slug": "hanwha",
    "name": "Hanwha",
    "cameraCount": 842
  },
  {
    "slug": "i-pro",
    "name": "i-PRO",
    "cameraCount": 829
  },
  {
    "slug": "bosch",
    "name": "Bosch",
    "cameraCount": 777
  },
  {
    "slug": "milesight",
    "name": "Milesight",
    "cameraCount": 713
  },
  {
    "slug": "acti",
    "name": "ACTi",
    "cameraCount": 626
  },
  {
    "slug": "pelco",
    "name": "Pelco",
    "cameraCount": 611
  },
  {
    "slug": "avigilon",
    "name": "Avigilon",
    "cameraCount": 572
  },
  {
    "slug": "tvt",
    "name": "TVT",
    "cameraCount": 543
  },
  {
    "slug": "hilook",
    "name": "HiLook",
    "cameraCount": 534
  },
  {
    "slug": "cp-plus",
    "name": "CP Plus",
    "cameraCount": 483
  },
  {
    "slug": "tiandy",
    "name": "Tiandy",
    "cameraCount": 460
  },
  {
    "slug": "trassir",
    "name": "TRASSIR",
    "cameraCount": 402
  },
  {
    "slug": "ezviz",
    "name": "Ezviz",
    "cameraCount": 367
  },
  {
    "slug": "sunell",
    "name": "Sunell",
    "cameraCount": 362
  },
  {
    "slug": "vivotek",
    "name": "Vivotek",
    "cameraCount": 353
  },
  {
    "slug": "lorex",
    "name": "Lorex",
    "cameraCount": 329
  },
  {
    "slug": "ltv",
    "name": "LTV",
    "cameraCount": 328
  },
  {
    "slug": "verkada",
    "name": "Verkada",
    "cameraCount": 325
  },
  {
    "slug": "amcrest",
    "name": "Amcrest",
    "cameraCount": 307
  },
  {
    "slug": "merit-lilin",
    "name": "Merit Lilin",
    "cameraCount": 300
  },
  {
    "slug": "idis",
    "name": "IDIS",
    "cameraCount": 298
  },
  {
    "slug": "provision-isr",
    "name": "Provision-ISR",
    "cameraCount": 297
  },
  {
    "slug": "bcs",
    "name": "BCS",
    "cameraCount": 273
  },
  {
    "slug": "reolink",
    "name": "Reolink",
    "cameraCount": 263
  },
  {
    "slug": "geovision",
    "name": "GeoVision",
    "cameraCount": 262
  },
  {
    "slug": "imou",
    "name": "Imou",
    "cameraCount": 259
  },
  {
    "slug": "swann",
    "name": "Swann",
    "cameraCount": 258
  },
  {
    "slug": "zkteco",
    "name": "ZKTeco",
    "cameraCount": 255
  },
  {
    "slug": "honeywell",
    "name": "Honeywell",
    "cameraCount": 253
  },
  {
    "slug": "hiwatch",
    "name": "HiWatch",
    "cameraCount": 252
  },
  {
    "slug": "kedacom",
    "name": "KEDACOM",
    "cameraCount": 250
  },
  {
    "slug": "flir",
    "name": "FLIR",
    "cameraCount": 239
  },
  {
    "slug": "lts",
    "name": "LTS",
    "cameraCount": 191
  },
  {
    "slug": "mobotix",
    "name": "Mobotix",
    "cameraCount": 178
  },
  {
    "slug": "longse",
    "name": "Longse",
    "cameraCount": 177
  },
  {
    "slug": "ajax",
    "name": "Ajax",
    "cameraCount": 174
  },
  {
    "slug": "digital-watchdog",
    "name": "Digital Watchdog",
    "cameraCount": 171
  },
  {
    "slug": "kenik",
    "name": "Kenik",
    "cameraCount": 170
  },
  {
    "slug": "samsung",
    "name": "Samsung",
    "cameraCount": 167
  },
  {
    "slug": "arecont-vision",
    "name": "Arecont Vision",
    "cameraCount": 125
  },
  {
    "slug": "avycon",
    "name": "Avycon",
    "cameraCount": 116
  },
  {
    "slug": "abus",
    "name": "ABUS",
    "cameraCount": 115
  },
  {
    "slug": "ganz-security",
    "name": "GANZ Security",
    "cameraCount": 113
  },
  {
    "slug": "intelbras",
    "name": "Intelbras",
    "cameraCount": 105
  },
  {
    "slug": "invid-tech",
    "name": "InVid Tech",
    "cameraCount": 104
  },
  {
    "slug": "speco-technologies",
    "name": "Speco Technologies",
    "cameraCount": 103
  },
  {
    "slug": "uniarch",
    "name": "Uniarch",
    "cameraCount": 100
  },
  {
    "slug": "annke",
    "name": "Annke",
    "cameraCount": 93
  },
  {
    "slug": "march-networks",
    "name": "March Networks",
    "cameraCount": 91
  },
  {
    "slug": "tp-link-vigi",
    "name": "TP-Link VIGI",
    "cameraCount": 91
  },
  {
    "slug": "empire-tech",
    "name": "Empire Tech",
    "cameraCount": 77
  },
  {
    "slug": "grundig-security",
    "name": "Grundig Security",
    "cameraCount": 76
  },
  {
    "slug": "wisenet",
    "name": "Wisenet",
    "cameraCount": 76
  },
  {
    "slug": "luminys",
    "name": "Luminys",
    "cameraCount": 68
  },
  {
    "slug": "holowits",
    "name": "Holowits",
    "cameraCount": 64
  },
  {
    "slug": "urmet",
    "name": "Urmet",
    "cameraCount": 63
  },
  {
    "slug": "vicon",
    "name": "Vicon",
    "cameraCount": 62
  },
  {
    "slug": "vstarcam",
    "name": "Vstarcam",
    "cameraCount": 62
  },
  {
    "slug": "hi-focus",
    "name": "Hi-Focus",
    "cameraCount": 60
  },
  {
    "slug": "rhombus",
    "name": "Rhombus",
    "cameraCount": 60
  },
  {
    "slug": "tp-link",
    "name": "TP-Link",
    "cameraCount": 59
  },
  {
    "slug": "prama",
    "name": "Prama",
    "cameraCount": 56
  },
  {
    "slug": "luma-surveillance",
    "name": "Luma Surveillance",
    "cameraCount": 55
  },
  {
    "slug": "tp-link-tapo",
    "name": "TP-Link Tapo",
    "cameraCount": 54
  },
  {
    "slug": "novicam",
    "name": "Novicam",
    "cameraCount": 53
  },
  {
    "slug": "comelit",
    "name": "Comelit",
    "cameraCount": 52
  },
  {
    "slug": "foscam",
    "name": "Foscam",
    "cameraCount": 52
  },
  {
    "slug": "trendnet",
    "name": "TRENDnet",
    "cameraCount": 47
  },
  {
    "slug": "eufy",
    "name": "Eufy",
    "cameraCount": 46
  },
  {
    "slug": "ubiquiti-unifi-protect",
    "name": "Ubiquiti UniFi Protect",
    "cameraCount": 46
  },
  {
    "slug": "genie-cctv",
    "name": "Genie CCTV",
    "cameraCount": 44
  },
  {
    "slug": "openeye",
    "name": "OpenEye",
    "cameraCount": 37
  },
  {
    "slug": "cnb",
    "name": "CNB",
    "cameraCount": 35
  },
  {
    "slug": "indigovision",
    "name": "IndigoVision",
    "cameraCount": 35
  },
  {
    "slug": "tyco-illustra",
    "name": "Tyco Illustra",
    "cameraCount": 35
  },
  {
    "slug": "wyze",
    "name": "Wyze",
    "cameraCount": 34
  },
  {
    "slug": "eneo",
    "name": "eneo",
    "cameraCount": 32
  },
  {
    "slug": "oncam-grandeye",
    "name": "Oncam Grandeye",
    "cameraCount": 32
  },
  {
    "slug": "bolide",
    "name": "Bolide",
    "cameraCount": 30
  },
  {
    "slug": "ivsec",
    "name": "IVSEC",
    "cameraCount": 30
  },
  {
    "slug": "matrix-comsec",
    "name": "Matrix Comsec",
    "cameraCount": 27
  },
  {
    "slug": "videotec",
    "name": "Videotec",
    "cameraCount": 27
  },
  {
    "slug": "xiaomi",
    "name": "Xiaomi",
    "cameraCount": 26
  },
  {
    "slug": "arlo",
    "name": "Arlo",
    "cameraCount": 25
  },
  {
    "slug": "eagle-eye-networks",
    "name": "Eagle Eye Networks",
    "cameraCount": 24
  },
  {
    "slug": "truen",
    "name": "Truen",
    "cameraCount": 24
  },
  {
    "slug": "meriva-technology",
    "name": "Meriva Technology",
    "cameraCount": 23
  },
  {
    "slug": "ring",
    "name": "Ring",
    "cameraCount": 21
  },
  {
    "slug": "inner-range",
    "name": "Inner Range",
    "cameraCount": 20
  },
  {
    "slug": "inim-electronics",
    "name": "INIM Electronics",
    "cameraCount": 18
  },
  {
    "slug": "sv3c",
    "name": "SV3C",
    "cameraCount": 17
  },
  {
    "slug": "ic-realtime",
    "name": "IC Realtime",
    "cameraCount": 16
  },
  {
    "slug": "polyvision",
    "name": "Polyvision",
    "cameraCount": 16
  },
  {
    "slug": "google-nest",
    "name": "Google Nest",
    "cameraCount": 12
  },
  {
    "slug": "instar",
    "name": "INSTAR",
    "cameraCount": 12
  },
  {
    "slug": "blink",
    "name": "Blink",
    "cameraCount": 11
  },
  {
    "slug": "costar",
    "name": "Costar",
    "cameraCount": 10
  },
  {
    "slug": "tp-link-kasa",
    "name": "TP-Link Kasa",
    "cameraCount": 10
  },
  {
    "slug": "aqara",
    "name": "Aqara",
    "cameraCount": 9
  },
  {
    "slug": "lupus-electronics",
    "name": "Lupus Electronics",
    "cameraCount": 9
  },
  {
    "slug": "synology",
    "name": "Synology",
    "cameraCount": 7
  },
  {
    "slug": "yale",
    "name": "Yale",
    "cameraCount": 7
  },
  {
    "slug": "laview",
    "name": "LaView",
    "cameraCount": 6
  },
  {
    "slug": "camius",
    "name": "Camius",
    "cameraCount": 4
  },
  {
    "slug": "canon",
    "name": "Canon",
    "cameraCount": 4
  },
  {
    "slug": "godrej",
    "name": "Godrej",
    "cameraCount": 4
  },
  {
    "slug": "linovision",
    "name": "Linovision",
    "cameraCount": 4
  },
  {
    "slug": "netatmo",
    "name": "Netatmo",
    "cameraCount": 4
  },
  {
    "slug": "qubo",
    "name": "Qubo",
    "cameraCount": 4
  },
  {
    "slug": "simplisafe",
    "name": "SimpliSafe",
    "cameraCount": 4
  },
  {
    "slug": "adt",
    "name": "ADT",
    "cameraCount": 3
  },
  {
    "slug": "jovision",
    "name": "Jovision",
    "cameraCount": 3
  },
  {
    "slug": "norden",
    "name": "Norden",
    "cameraCount": 3
  },
  {
    "slug": "somfy",
    "name": "Somfy",
    "cameraCount": 3
  },
  {
    "slug": "hive",
    "name": "Hive",
    "cameraCount": 2
  },
  {
    "slug": "netcamcenter",
    "name": "NetCamCenter",
    "cameraCount": 2
  },
  {
    "slug": "steinel",
    "name": "Steinel",
    "cameraCount": 2
  },
  {
    "slug": "360-vision-technology",
    "name": "360 Vision Technology",
    "cameraCount": 1
  },
  {
    "slug": "bosch-smart-home",
    "name": "Bosch Smart Home",
    "cameraCount": 1
  }
];

/** Cameras whose manufacturer has too few models for a hub — linked directly. */
export const HUB_ORPHAN_CAMERAS: OrphanCamera[] = [];
